import { Paper, Text } from "@mantine/core"
import type React from "react"

interface CardProps {
  title: React.ReactNode
  children: React.ReactNode
}

const Card: React.FC<CardProps> = ({ title, children }) => {
  return (
    <Paper withBorder shadow="sm" w="100%" style={{ overflow: "hidden" }}>
      <div className="px-4 py-3" style={{ borderBottom: "1px solid var(--mantine-color-gray-3)" }}>
        <Text fw={600} size="md">
          {title}
        </Text>
      </div>
      {children}
    </Paper>
  )
}

export default Card
